import { message } from "antd";

/**
 *  
         "Erreur lors de la mise à jour du client"
       );
 * @param {*} errors 
 * @param {*} defaultError 
 */
export const getMessageError = (errors, defaultError) => {
  if (!errors) {
    message.error(defaultError || "Une erreur s'est produite");
    return;
  }
  
  // Handle string errors directly
  if (typeof errors === 'string') {
    message.error(errors);
    return;
  }
  
  const errorList = [];
  Object.entries(errors).forEach(([key, value]) => {
    // Handle array values (like {cin: ["The cin has already been taken."]})
    if (Array.isArray(value)) {
      errorList.push(...value);
    } else {
      errorList.push(value);
    }
  });

  if (errorList.length === 0) {
    message.error(defaultError || "Une erreur s'est produite");
  } else {
    errorList.forEach((err) => message.error(err));
  }
};
